<!--
캠페인 리스트를 띄우는 컴포넌트.
-->
<template>
  <div class="campaign-list">
    <h1>캠페인 리스트</h1>

    <campaign-calendar :schdules="schdules" @change-date="onChangeDate" />

    <campaign-items
      :items="campaigns"
      :is-admin="admin"
      @delete="deleteHandler"
      @modify="modifyToggleHandler"
      @view="rowClickHandler"
    />

    <pb-float-button fab title="추가하기" @click="toggleHandler">
      <i class="fas fa-plus"></i>
    </pb-float-button>

    <add-campaign-modal
      v-model="toggle"
      :data="data"
      :managers="managers"
      :user="user"
      :mode="mode"
      :campaign="campaign"
      @insert="campaignAddHandler"
      @update="campaignModifyHandler"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import dayjs from "dayjs";

import AddCampaignModal from "@/components/campaign/AddCampaignModal";
import CampaignItems from "@/components/campaign/CampaignItems.vue";
import CampaignCalendar from "@/components/campaign/CampaignCalendar.vue";

export default {
  name: "CampaignList",
  components: {
    AddCampaignModal,
    CampaignItems,
    CampaignCalendar,
  },
  data: () => ({
    toggle: false,
    loading: false,
    data: null,
    mode: "write",
    error: "",
    columns: [
      { key: "index", title: "#", width: 60 },
      { key: "name", title: "캠페인명", align: "left" },
      { key: "start_date", title: "시작일", width: 110 },
      { key: "end_date", title: "종료일", width: 110 },
      { key: "author", title: "발주자", width: 100 },
      { key: "status", title: "상태", width: 80 },
      { key: "update", title: "수정", width: 60, clickabled: false },
      { key: "delete", title: "삭제", width: 60, clickabled: false },
    ],
  }),
  computed: {
    ...mapState({
      campaign: "campaign",
      campaigns: "campaigns",
      managers: "managers",
      user: "user",
      schdules: "schdules",
    }),

    admin() {
      return this.user.position === "구성원";
    },
  },
  methods: {
    ...mapMutations(["SET_CAMPAIGNS_STATUS", "SET_CAMPAIGN", "SET_ITEMS"]),

    ...mapActions([
      "FETCH_CAMPAIGNS",
      "DELETE_CAMPAIGN",
      "FETCH_USERS",
      "FETCH_SCEDULE",
      "ADD_CAMPAIGN",
      "UPDATE_CAMPAIGN",
    ]),

    rowClickHandler(item) {
      if (
        this.user.position == "구성원" ||
        item.ksia_member === this.user.idx
      ) {
        this.SET_ITEMS(new Array());
        this.SET_CAMPAIGN(item);
        this.$router.push({ name: "CampaignDetail", params: { id: item.idx } });
      }
    },

    toggleHandler() {
      this.toggle = !this.toggle;
    },

    fetchData() {
      this.loading = true;
      return this.FETCH_CAMPAIGNS().finally(() => {
        this.loading = false;
      });
    },

    deleteHandler(idx) {
      this.$confirm.show({
        title: "캠페인 삭제",
        content: "삭제된 캠페인은 복구가 불가합니다.<br/>삭제하시겠습니까?",
        onConfirm: () => {
          this.DELETE_CAMPAIGN({ idx });
          this.$alert.info("삭제가 완료되었습니다.");
        },
      });
    },

    modifyToggleHandler(item) {
      this.data = {
        ...item,
        start_date: new Date(item.start_date).toISOString(),
        end_date: new Date(item.end_date).toISOString(),
      };
      this.mode = "modify";
      this.toggleHandler();
    },

    campaignModifyHandler(data) {
      const { idx, name, ksia_member, start_date, end_date } = data;
      // modify data
      this.UPDATE_CAMPAIGN({
        idx,
        payload: { name, ksia_member, start_date, end_date },
      });
      this.$alert.info("업데이트를 성공적으로 마쳤습니다.");
      this.data = null;
    },

    campaignAddHandler(data) {
      this.ADD_CAMPAIGN({ payload: data });
      this.$alert.info("광고가 등록되었습니다.");
    },

    cleanCampaign() {
      this.SET_CAMPAIGN({
        idx: null,
        name: null,
        ksia_member: this.user.id,
        start_date: null,
        end_date: null,
        campaign_items: null,
      });
    },

    onChangeDate(date) {
      this.FETCH_SCEDULE({ date });
    },

    getColor(status) {
      switch (status) {
        case "진행중":
          return "success";
        case "예약":
          return "disabled";
        case "종료":
          return "error";
        default:
          return "warn";
      }
    },
  },
  watch: {
    toggle(nVal) {
      if (!nVal) {
        // modal close timer 250ms
        setTimeout(() => {
          this.data = null;
          this.mode = "write";
        }, 250);
      }
    },
  },
  created() {
    const date = [dayjs().year(), dayjs().month() + 1];

    this.FETCH_USERS({ hook: null });
    this.FETCH_SCEDULE({ date });
    this.fetchData();
  },
};
</script>

<style scoped>
h1 {
  font-size: 24px;
  padding-top: 0.8rem;
  padding-bottom: 1.2rem;
}

span:hover {
  cursor: pointer;
  text-decoration: underline;
}
.status {
  color: #fff;
  padding: 0.5em 0.8em;
  border-radius: 24px;
}
.campaign_name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 22vw;
}
</style>
